var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer fixed"},[_c('div',{staticClass:"container"},[_vm._v(" สงวนสิทธิ์โดย บริษัท ไทยประกันชีวิต จำกัด (มหาชน) ")])])}]

export { render, staticRenderFns }